import * as PropTypes from "prop-types";
import classNames from "classnames";

const defaultPropTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  isLight: PropTypes.bool,
};

const renderButton = (classes, props) => {
  const { children, href, ...restProps } = props;

  const Tag = href ? "a" : "button";

  return (
    <Tag className={classNames(classes)} href={href} {...restProps}>
      {children}
    </Tag>
  );
};

export const ButtonWithTextPropTypes = {
  ...defaultPropTypes,
  hasFill: PropTypes.bool,
};

export class ButtonWithText extends React.PureComponent {
  static propTypes = ButtonWithTextPropTypes;

  render() {
    const {
      className,
      hasFill,
      hasFillAlt,
      isLight,
      hasFillInverted,
      hasFillVideo,
      ...restProps
    } = this.props;

    return renderButton(
      [
        "Button--withText",
        { [className]: className },
        { "Button--withTextHasFill": hasFill },
        { "Button--withTextHasFillAlt": hasFillAlt },
        { "Button--isLight": isLight },
        { "Button--withTextHasFillInverted": hasFillInverted },
        { "Button--withTextHasFillVideo": hasFillVideo },
      ],
      restProps
    );
  }
}

export const ButtonWithIconPropTypes = {
  ...defaultPropTypes,
  isLight: PropTypes.bool,
};

export class ButtonWithIcon extends React.PureComponent {
  static propTypes = ButtonWithIconPropTypes;

  render() {
    const { className, isLight, isSmall, ...restProps } = this.props;

    return renderButton(
      [
        "Button--withIcon",
        { [className]: className },
        { "Button--withIconIsSmall": isSmall },
        { "Button--isLight": isLight },
      ],
      restProps
    );
  }
}

export const ButtonLinkPropTypes = defaultPropTypes;

export class ButtonLink extends React.PureComponent {
  static propTypes = ButtonLinkPropTypes;

  render() {
    const { className, isLight, ...restProps } = this.props;

    return renderButton(
      [
        "Button--asLink",
        { [className]: className },
        { "Button--asLinkIsLight": isLight },
      ],
      restProps
    );
  }
}
